import { PlayerSowStoreContext } from "@state/context/sow/PlayerSowStoreContext";
import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { SowMultiSelect, SowSingleSelect } from ".";
import { useTranslation } from "react-i18next";

import { DateTime } from "luxon";

import { DatePicker, FormInputField } from "@components-shared/desktop/inputs";
import { InputTypeEnum } from "@data-types/sow/PlayerSowEnums";

export const SowQuestionFields = observer(function SowQuestionFields() {
	const playerSowStore = useContext(PlayerSowStoreContext);

	const { t } = useTranslation("registration");

	useEffect(() => {
		if (!playerSowStore) return;

		const getAllQuestions = async () => {
			await playerSowStore.fetchQuestions();

			if (playerSowStore.mappedQuestions.length !== 0) {
				playerSowStore.initializeAnswers(
					playerSowStore.mappedQuestions
				);
			}
		};

		getAllQuestions();
	}, []);

	if (!playerSowStore) {
		return null;
	}

	const maxDate = DateTime.now().minus({ years: 18 });
	const minDate = DateTime.now().minus({ years: 100 });

	return (
		<>
			<div className="u-type--base u-mar--top--xsml">
				{playerSowStore.mappedQuestions.map((question) => {
					if (question.type === InputTypeEnum.Text) {
						if (question.abrv === "userName") {
							return (
								<FormInputField
									disabled
									name={question.abrv}
									label={question.name}
									className="form__field"
									id={question.id}
									key={question.id}
									labelClassName="u-type--wgt--medium"
								/>
							);
						}
						return (
							<FormInputField
								required
								name={question.abrv}
								label={question.name}
								className="form__field"
								id={question.id}
								key={question.id}
								labelClassName="u-type--wgt--medium"
							/>
						);
					}

					if (question.type === InputTypeEnum.Date) {
						return (
							<DatePicker
								name={question.abrv}
								label={question.name}
								key={question.id}
								id={question.id}
								labelClassName="u-type--wgt--medium"
								className="form__field"
								required
								validate={{
									isOldEnough: (value: string) => {
										const dateValue =
											DateTime.fromISO(value);
										if (
											dateValue.startOf("day") >
											maxDate.startOf("day")
										) {
											return t("DOB_TOO_YOUNG");
										}
									},
									isTooOld: (value: string) => {
										const dateValue =
											DateTime.fromISO(value);

										if (
											dateValue.startOf("day") <
											minDate.startOf("day")
										) {
											return t<string>("DOB_INVALID");
										}
									},
								}}
							/>
						);
					}

					if (
						question.type === InputTypeEnum.CheckboxCustomMultiple
					) {
						return (
							<SowMultiSelect
								question={question}
								key={question.id}
							/>
						);
					}

					if (
						question.type === InputTypeEnum.CheckboxCustomOne ||
						question.type === InputTypeEnum.CheckboxOnly
					) {
						return (
							<SowSingleSelect
								question={question}
								key={question.id}
							/>
						);
					}
				})}
			</div>
		</>
	);
});
